<button mat-button [matMenuTriggerFor]="dateFilterMenu" class="date-filter-trigger">
    <div class="date-filter-trigger-content">
		<div>{{ fn_getSelectedDateText() }}</div>
		<mat-icon>expand_more</mat-icon>
	</div>
</button>

<mat-menu #dateFilterMenu="matMenu" class="date-filter-menu" [ngStyle]="{'--menu-padding': '0px'}" [hasBackdrop]="true" (closed)="resetCustomDatePicker()">
	<button mat-menu-item class="custom-mat-menu-item" (click)="fn_setDateFilter('thisMonth')">Este Mes</button>
	<button mat-menu-item class="custom-mat-menu-item" (click)="fn_setDateFilter('lastMonth')">Mes Pasado</button>
	<button mat-menu-item class="custom-mat-menu-item" (click)="fn_setDateFilter('thisYear')">Este Año</button>

	<button mat-menu-item class="custom-mat-menu-item" (click)="toggleCustomDatePicker(); $event?.stopPropagation()">
		Fechas Personalizadas
		<mat-icon *ngIf="!showCustomDatePicker">expand_more</mat-icon>
		<mat-icon *ngIf="showCustomDatePicker">expand_less</mat-icon>
	</button>

	<div *ngIf="showCustomDatePicker" class="custom-date-container" (click)="$event?.stopPropagation()">
		<mat-form-field>
		<mat-label>Fecha Inicio</mat-label>
		<input matInput 
			[matDatepicker]="startPicker" 
			[(ngModel)]="dateFilter.startDate" 
			(click)="$event?.stopPropagation()" 
			(ngModelChange)="onCustomDateChange()" placeholder="Fecha inicio"
			placeholder="Fecha inicio" 
		/>
		<mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
		<mat-datepicker #startPicker></mat-datepicker>
		</mat-form-field>

		<mat-form-field>
		<mat-label>Fecha Fin</mat-label>
		<input matInput 
			[matDatepicker]="endPicker" 
			[(ngModel)]="dateFilter.endDate"
			(click)="$event?.stopPropagation()" 
			(ngModelChange)="onCustomDateChange()" placeholder="Fecha inicio"
			placeholder="Fecha fin" />
		<mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
		<mat-datepicker #endPicker (closed)="$event?.stopPropagation()" ></mat-datepicker>
		</mat-form-field>
		<!-- <button mat-raised-button color="primary" (click)="fn_setDateFilter('custom')">
			Confirmar
		</button> -->
	</div>
</mat-menu>